export default __webpack_public_path__ + "static/media/twitter.5e25e7db.png";